import {Modal} from '@/components/ui/modal/Modal'
import {useTranslation} from 'react-i18next'
import {StyledSubTitle} from './style'
import {useEffect, useState} from 'react'
import {useBuyMicromorgiPackageV3} from '../queries/useBuyMicromorgiPackageV3'
import {ReachedLimitContent} from './components/reachedLimitContent/ReachedLimitContent'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useRootStore} from '@/store'
import {selectChoosePaymentsMethodModal, selectReachedLimitModal} from '@/store/selectors'
import {useMe} from '@/features/authentication/queries/useMe'
import {GuestTypeV3} from '@/features/authentication/types'
import {MicromorgiPackageV3} from '../buy-morgis-modal/BuyMorgisModal'

export enum Variants {
    PURCHASE = 'purchase',
    SUCCESS = 'success',
    FAILURE = 'failure'
}

export const ReachedLimitModal = ({onCloseCallBack}: {onCloseCallBack?: () => void}) => {
    const {t} = useTranslation()
    const {data} = useMe()
    const user = data as GuestTypeV3
    const firstTransaction = user?.typeAttributes.isFirstTransaction
    const {closeModal: closeModalHandler} = useRootStore(selectReachedLimitModal)
    const {openModal: openChoosePaymentsMethodModal} = useRootStore(selectChoosePaymentsMethodModal)
    const [selectedOption, setSelectedOption] = useState<MicromorgiPackageV3 | undefined>(undefined)
    const {
        mutate: buyMicromorgiPackage,
        data: buyMicromorgiPackageData,
        error: buyMicromorgiPackageError,
        isPending
    } = useBuyMicromorgiPackageV3()
    const [variant, setVariant] = useState<Variants>(Variants.PURCHASE)

    useEffect(() => {
        if (buyMicromorgiPackageData) {
            setVariant(Variants.SUCCESS)
        }
        if (buyMicromorgiPackageError && firstTransaction) {
            if (buyMicromorgiPackageError?.response?.status === 303) {
                openChoosePaymentsMethodModal({
                    paymentMethodUrls: buyMicromorgiPackageError?.response?.data
                })
            }
        }
        if (buyMicromorgiPackageError) {
            setVariant(Variants.FAILURE)
        }
    }, [buyMicromorgiPackageData, buyMicromorgiPackageError])

    const backToBuyMicromorgiPackage = () => {
        setVariant(Variants.PURCHASE)
    }

    const findSelectedOption = (pack: MicromorgiPackageV3) => {
        return pack === selectedOption
    }
    const selectPackClick = (pack: MicromorgiPackageV3) => {
        setSelectedOption(pack)
    }

    const handleBuyMicromorgiPackage = (packageId: string) => {
        buyMicromorgiPackage({packageId: packageId})
    }

    return (
        <Modal
            onClose={onCloseCallBack ? onCloseCallBack : closeModalHandler}
            maxHeight={'600px'}
            height={'550px'}
            title={t('riched_limit_modal:title')}
            subHeader={<StyledSubTitle>{t('riched_limit_modal:subtitle')}</StyledSubTitle>}
        >
            {isPending ? (
                <Spinner />
            ) : (
                <div>
                    <ReachedLimitContent
                        variant={variant}
                        backToBuyMicromorgiPackage={backToBuyMicromorgiPackage}
                        findSelectedOption={findSelectedOption}
                        handleBuyMicromorgiPackage={handleBuyMicromorgiPackage}
                        selectedOption={selectedOption}
                        selectPackClick={selectPackClick}
                    />
                </div>
            )}
        </Modal>
    )
}
